const { Text } = require('@chakra-ui/react');

export function SectionTitle(props) {
  return (
    <Text fontSize="1.4rem" fontWeight="600" mb="16px" {...props}>
      {props.children}
    </Text>
  );
}
